export default "__VITE_ASSET__ndL70FhR__"